import { forwardRef, MouseEventHandler } from 'react';
import cn from 'classnames';
import {
  getSShiftPrimaryText,
  getSShiftSecondaryText,
  getSShiftTypeColors,
} from '@lp/features/Scheduler/SchedulerSurgeons/utils';
import { ShiftButton } from '@lp/features/Scheduler/components';
import { SShift, SShiftType } from '@/api/apis/resources/schedule';
import { formatDate } from '@/utils/helpers';

type NAShiftButtonProps = {
  shiftData: SShift;
  lighten?: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const NAShiftButton = forwardRef<HTMLButtonElement, NAShiftButtonProps>(
  ({ shiftData, lighten, disabled, onClick }, ref) => {
    const { unavailabilities } = shiftData;
    const primaryText = getSShiftPrimaryText(shiftData);
    const secondaryText = getSShiftSecondaryText(shiftData, true);
    const colors = getSShiftTypeColors(shiftData);
    const naColors = getSShiftTypeColors({ ...shiftData, shiftType: SShiftType.Unavailable });
    const naClassname = cn(naColors.bg, naColors.border);
    const firstNa = unavailabilities?.[0];

    return (
      <div className="flex flex-col items-start justify-between h-full w-full z-1">
        <ShiftButton
          ref={ref}
          lighten={lighten}
          disabled={disabled}
          className={cn(colors.bg, colors.text, colors.border, 'rounded! h-5')}
          onClick={onClick}
        >
          <div className="flex items-center justify-between w-full h-full text-xs-r">
            <span className="flex items-center gap-1">{primaryText}</span>
            <span>{secondaryText}</span>
          </div>
        </ShiftButton>
        <div className={cn('flex gap-0.5 text-danger-5 w-full', { 'opacity-60': lighten })}>
          <div className={cn(naClassname, 'flex items-center h-5 gap-1 grow px-2 py-1 rounded')}>
            <span className="text-xs-m">N/A</span>
            <span className="text-xs-r">
              {formatDate(firstNa?.from, 'HH:mm')} - {formatDate(firstNa?.to, 'HH:mm')}
            </span>
          </div>
          {unavailabilities?.length && unavailabilities?.length > 1 && (
            <div className={cn(naClassname, 'flex items-center h-5 p-1 rounded text-xs-m')}>
              +{unavailabilities.length - 1}
            </div>
          )}
        </div>
      </div>
    );
  },
);
